import { Facebook, Instagram } from "lucide-react";
import { useStore } from "../../context/StoreContext";

const TikTok = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
    <path d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 1 1-2.59-2.59c.27 0 .53.04.77.12V9.77a5.7 5.7 0 0 0-.77-.05A5.68 5.68 0 1 0 15.54 15.4V9.01a7.3 7.3 0 0 0 4.3 1.38V7.3a4.28 4.28 0 0 1-3.24-1.48Z" />
  </svg>
);
const Pinterest = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
    <path d="M12 2a10 10 0 0 0-3.64 19.31c-.09-.79-.16-2 .03-2.86l1.17-4.97s-.3-.6-.3-1.48c0-1.39.81-2.43 1.81-2.43.86 0 1.27.64 1.27 1.41 0 .86-.55 2.15-.83 3.34-.24 1 .5 1.81 1.48 1.81 1.78 0 3.15-1.88 3.15-4.59 0-2.4-1.72-4.08-4.19-4.08-2.85 0-4.53 2.14-4.53 4.35 0 .86.33 1.79.75 2.29.08.1.09.19.07.29l-.28 1.13c-.04.18-.15.22-.33.13-1.25-.58-2.03-2.4-2.03-3.87 0-3.15 2.29-6.04 6.6-6.04 3.46 0 6.16 2.47 6.16 5.77 0 3.44-2.17 6.21-5.18 6.21-1.01 0-1.97-.53-2.29-1.15l-.62 2.38c-.23.87-.84 1.96-1.25 2.62A10 10 0 1 0 12 2Z" />
  </svg>
);

const ICONS = { instagram: Instagram, facebook: Facebook, tiktok: TikTok, pinterest: Pinterest };

export const SocialIcons = ({ className = "" }) => {
  const { settings } = useStore();
  const social = settings?.social || {};
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {Object.entries(ICONS).map(([k, Icon]) =>
        social[k] ? (
          <a
            key={k}
            href={social[k]}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Vacation Apparel on ${k}`}
            className="w-11 h-11 rounded-full grid place-items-center bg-white/10 hover:bg-sun hover:text-navy transition-colors"
            data-testid={`social-link-${k}`}
          >
            <Icon className="w-5 h-5" />
          </a>
        ) : null
      )}
    </div>
  );
};
